import * as XLSX from 'xlsx-js-style';
import type { ExcelTemplate } from '../../interfaces';
import { ModelForTableDTO } from 'src/app/domain/follow-on/component/dto/ModelForTableDTO';
import { getPreparedData } from './mapping';
import { CA_HEADERS } from './headers';
import { CommitmentAllocationModelExcelExport } from 'src/app/domain/follow-on/component/commitment-allocation-model-table/commitment-allocation-model-table.component';
import { fitToColumn } from '../financial-statement/utils';
import { setColumnWidth, withHeaderStyling } from '../../utils/styles';

export class CommitmentAllocationTemplate implements ExcelTemplate {
  export(commitmentAllocationModels: CommitmentAllocationModelExcelExport): XLSX.WorkBook {
    const book = XLSX.utils.book_new();
    const sheet1 = this.getSheet(commitmentAllocationModels, 'growthPrediction');
    const sheet2 = this.getSheet(commitmentAllocationModels, 'investmentAllocation');
    XLSX.utils.book_append_sheet(book, sheet1);
    XLSX.utils.book_append_sheet(book, sheet2);
    return book;
  }

  /**
   * Here I'm using array of arrays, because I need prepare cells properly with
   * format, styles, etc.
   */
  getSheet(commitmentAllocation: CommitmentAllocationModelExcelExport, type: string): XLSX.WorkSheet {
    const headers = CA_HEADERS[type];
    const preparedData = getPreparedData(commitmentAllocation, headers);
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      ' !cols': fitToColumn(preparedData),
    };
    const whiteSpaceIndexses = [3, 9, 15];
    whiteSpaceIndexses.forEach((index) => setColumnWidth(sheet, index, 1));
    const wideColumns = [0, 1, 4, 5, 6, 7, 8, 10, 11, 12, 13, 14, 16, 17, 18, 20, 21, 22, 23, 24, 25, 26];
    const superWideColumns = [2];
    wideColumns.forEach((index) => setColumnWidth(sheet, index, 15));
    superWideColumns.forEach((index) => setColumnWidth(sheet, index, 20));
    return withHeaderStyling(sheet);
  }

}

export interface CommitmentAllocation {
  active: ModelForTableDTO;
  sold: ModelForTableDTO;
}


